// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"00170539","278":"3710b6c2"}[chunkId] + ".chunk.js";
};